import type { TResolvedItemNames } from '@modules/items';
import { newBlockIds, withBlocksData, withoutBlocksData } from '@modules/documents/helpers/withBlocksData.helper';
import { newRefIds, withRefsData, withoutRefsData } from '@modules/documents/helpers/withRefsData.helper';
import type { TDocument } from '@modules/documents/types/documents.types';

import type { TAiEditResultResponse } from './types';

export type TAiEditRunCache = { docId: string; refIds: string[]; blockIds: string[] };

export const mergeRunData = (
  doc: TDocument,
  resolvedItemNames: TResolvedItemNames,
  response: TAiEditResultResponse
): { doc: TDocument; resolvedItemNames: TResolvedItemNames } =>
  withBlocksData(
    withRefsData(doc, response.refsData),
    resolvedItemNames,
    response.blocksData,
    response.resolvedItemNames
  );

export const newRunCacheIds = (
  doc: TDocument,
  response: TAiEditResultResponse
): Pick<TAiEditRunCache, 'refIds' | 'blockIds'> => ({
  refIds: newRefIds(doc, response.refsData),
  blockIds: newBlockIds(doc, response.blocksData),
});

export const withoutRunData = (doc: TDocument, runCache: TAiEditRunCache): TDocument =>
  withoutBlocksData(withoutRefsData(doc, runCache.refIds), runCache.blockIds);
